export default {
  allSubMarkets: {
    id: 'bo_seller.options.shipping.category_list.toggle_market.all_sub_markets',
    defaultMessage: 'All states',
  },
}
